module.exports = __webpack_public_path__ + "static/media/device-token.ab7f1d1f.svg";